
import { validationMixin } from "vuelidate";
import ObjetoData, { ObjetoDataRequired } from "./ObjetoData";
import { mapGetters } from "vuex";
import _ from "lodash";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import PessoaMixin from "@/modules/Application/mixins/PessoaMixin";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-objetos-form",
  props: {
    url: {
      type: String,
    },
    objeto: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin, PessoaMixin, SistemaMixin],
  components: {
    VueSelect,
  },
  data() {
    return {
      tabIndex: 0,
      form: {},
      clientes: [],
      valueCliente: null,
      identificadores: [],
      identificadoresFilled: {},
    };
  },
  validations: {
    form: ObjetoDataRequired,
  },
  watch: {
    objeto(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
        if (newValue) {
          this.valueCliente = newValue.pessoa;
        }
        const identificadoresParsed = this.ordenarIdentificadores(
          newValue.identificadores
        );

        this.identificadoresFilled = this.getIdentificadoresFilled(
          identificadoresParsed
        );
        this.form.identificadores = this.buildIdentificadoresPayload(
          this.identificadoresFilled
        );
      } else {
        this.identificadoresFilled = this.identificadores.reduce(
          (acc, identificador) => ({
            ...acc,
            [identificador.descricao]: null,
          }),
          {}
        );
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  methods: {
    async getDataInit() {
      this.form = await new ObjetoData({});

      const { data } = await this.$http.post(
        "/identificador/get-identificador"
      );
      this.identificadores = this.ordenarIdentificadores(data);
      this.form.identificadores = this.buildIdentificadoresPayload();
    },
    ordenarIdentificadores(identificadores) {
      if (typeof identificadores === "string") {
        try {
          identificadores = JSON.parse(identificadores);
        } catch (e) {
          return [];
        }
      }
      if (!Array.isArray(identificadores)) return [];

      return [...identificadores].sort(
        (a, b) =>
          Number(a?.id_identificador || 0) -
          Number(b?.id_identificador || 0)
      );
    },
    placeholderIdentificador(identificador) {
      return this.isIdentificadorObrigatorio(identificador)
        ? ""
        : "Identificador não obrigatório";
    },
    isIdentificadorObrigatorio(identificador) {
      return ![false, 0, "0"].includes(identificador.obrigatorio);
    },
    isValorPreenchido(value) {
      return value !== null && value !== undefined && String(value).trim() !== "";
    },
    getValorIdentificador(identificadores, descricao) {
      if (!Array.isArray(identificadores)) return null;

      const identificador = identificadores.find(
        (item) => item.descricao === descricao
      );

      return identificador?.value ?? null;
    },
    getIdentificadoresFilled(identificadores) {
      return this.identificadores.reduce((acc, identificador) => ({
        ...acc,
        [identificador.descricao]: this.getValorIdentificador(
          identificadores,
          identificador.descricao
        ),
      }), {});
    },
    buildIdentificadoresPayload(values = this.identificadoresFilled) {
      return this.identificadores.reduce((acc, identificador) => {
        const value = values[identificador.descricao] ?? null;

        if (
          this.isIdentificadorObrigatorio(identificador) ||
          this.isValorPreenchido(value)
        ) {
          acc.push({
            id_identificador: identificador.id_identificador,
            descricao: identificador.descricao,
            value,
          });
        }

        return acc;
      }, []);
    },
    changeValues(key, value) {
      this.identificadoresFilled[key] = value;
      this.form = {
        ...this.form,
        identificadores: this.buildIdentificadoresPayload(),
      };
    },
    setAtivo() {
      this.form.status = this.form.status == true ? false : true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_novo_objeto"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        if (this.valueCliente) {
          this.form.id_pessoa = this.valueCliente.id_pessoa;
        }

        await this.$http.post(this.url, this.form);

        this.$router.push({ name: "objetosLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
    setCliente(cliente) {
      this.valueCliente = cliente;
    },
    onSearchCliente(search, loading) {
      if (search.length) {
        loading(true);
        this.searchClient(loading, search, this);
      }
    },
    searchClient: _.debounce(async (loading, search, vm) => {
      vm.clientes = await vm.getPessoaNome(search);
      loading(false);
    }, 450),
  },
};
